import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// data
import { trackHeaderPromoClicked } from "core/trackEvent.js";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// styles
import Link from "core/Link";
import { convertPxToRem } from "frontend/components/helpers";
import { focusInset } from "core/links";

const OpenModalButtonStyled = styled(Link)`
    height: ${convertPxToRem(30)};

    // Link's default focus ring is an outward box-shadow, which gets clipped
    // by the message container's overflow: hidden (used for text truncation).
    // Use an inset ring instead so it stays within the button's own bounds.
    &:focus:not(:focus-visible) {
        box-shadow: none;
    }

    &:focus {
        ${focusInset}
    }
`;

// component
export const OpenModalButton = ({ onClick, children, ...rest }) => {
    const { isDarkMode } = useSiteHeader();

    return (
        <OpenModalButtonStyled
            onClick={onClick}
            darkMode={isDarkMode}
            data-testid="open-modal-button"
            isButton
            disableVisitedStyle
            onMouseDown={trackHeaderPromoClicked}
            {...rest}
        >
            {children}
        </OpenModalButtonStyled>
    );
};

export default OpenModalButton;

// prop-types
OpenModalButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    children: PropTypes.any,
};
